/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SdsAccountInfo
 */
export interface SdsAccountInfo {
    /**
     * 
     * @type {string}
     * @memberof SdsAccountInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SdsAccountInfo
     */
    publicContentDir: string;
}

export function SdsAccountInfoFromJSON(json: any): SdsAccountInfo {
    return SdsAccountInfoFromJSONTyped(json, false);
}

export function SdsAccountInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SdsAccountInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'publicContentDir': json['publicContentDir'],
    };
}

export function SdsAccountInfoToJSON(value?: SdsAccountInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'publicContentDir': value.publicContentDir,
    };
}


